import { Injectable } from "@angular/core";
import { TipoOcorrencia } from "@tivic-team/manager-ts/dist/grl/entities/tipo-ocorrencia.entity";
import { TipoOcorrenciaController } from "app/controllers/grl/tipo-ocorrencia.controller";
import { LoaderService } from "../loader.service";
import { TipoOcorrenciaSearch } from "./tipo-ocorrencia.search";

@Injectable()
export class TipoOcorrenciaService {

    constructor(
        private _tipoOcorrenciaController: TipoOcorrenciaController,
        private _loaderService: LoaderService,
    ) { }

    async find( tipoOcorrenciaSearch?: TipoOcorrenciaSearch ): Promise< TipoOcorrencia[] > {
        this._loaderService.show();
        try {
            return await this._tipoOcorrenciaController.find( ( tipoOcorrenciaSearch && tipoOcorrenciaSearch.getFilters() ) || null ).finally( () => this._loaderService.hide() );
            
        } catch( error ) {
            this._loaderService.hide();
            return [];
        }
    }

    async save( tipoOcorrencia: TipoOcorrencia ):Promise< TipoOcorrencia > {
        this._loaderService.show();
        if( tipoOcorrencia.cdTipoOcorrencia && tipoOcorrencia.cdTipoOcorrencia > 0 ) {

            return this._tipoOcorrenciaController.update( tipoOcorrencia ).finally( () => this._loaderService.hide() );
        } else {
            return this._tipoOcorrenciaController.create( tipoOcorrencia ).finally( () => this._loaderService.hide() );
        }
    }

    async get( cdTipoOcorrencia:number):Promise< TipoOcorrencia >{
        this._loaderService.show();
        return this._tipoOcorrenciaController.get( cdTipoOcorrencia ).finally(() => this._loaderService.hide());
    }
}